/** Generate unique id for elements */
const createUID = (): string => {
  return `_${Math.random().toString(36).slice(2, 11)}`;
};

export default createUID;
